import React, { useMemo, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import BillOfLading, { BillOfLadingData } from './BillOfLading';
import { sharedPrintStyles, basePrintContainerStyle } from './printStyles';

const errorStyles: React.CSSProperties = {
  padding: '20px',
  textAlign: 'center',
  color: '#cc0000',
};

function decodePayload(params: URLSearchParams): BillOfLadingData | null {
  const payload = params.get('data');
  if (!payload) return null;
  try {
    return JSON.parse(decodeURIComponent(payload)) as BillOfLadingData;
  } catch {
    return null;
  }
}

const BillOfLadingPrintPage: React.FC = () => {
  const [params] = useSearchParams();
  const data = useMemo(() => decodePayload(params), [params]);

  useEffect(() => {
    console.log('BillOfLadingPrintPage mounted', { hasData: !!data });
  }, [data]);

  if (!data) {
    return (
      <div className="print-page" style={errorStyles}>
        <p>Missing or invalid print payload.</p>
      </div>
    );
  }

  return (
    <div className="print-page" style={pageStyle}>
      <style>{sharedPrintStyles}</style>
      <BillOfLading {...data} />
    </div>
  );
};

const pageStyle: React.CSSProperties = {
  ...basePrintContainerStyle,
  padding: '10mm',
};

export default BillOfLadingPrintPage;

